export const strComparator = (a: string, b: string) => {
	const nameA = a?.toUpperCase() // ignore upper and lowercase
	const nameB = b?.toUpperCase() // ignore upper and lowercase
	return nameA > nameB ? 1 : nameA < nameB ? -1 : 0
}